"use client";

import { motion } from "framer-motion";
import { headerVariants, slideFromBottomVariants, cardVariants } from "@/lib/animations";
import YachtPriceCalendar, { type YachtMonthlyPrice } from "@/components/ui/YachtPriceCalendar";

/** Kiralama tipi: günlük, haftalık, aylık - fiyat etiketlemesi için */
export type RentalType = 'daily' | 'weekly' | 'monthly';

interface ProductYachtPricesProps {
    monthlyPrices: YachtMonthlyPrice[];
    currency: string;
    title: string;
    /** Kiralama tipi; haftalık üründe "Haftalık kiralama" vb. gösterilir */
    rentalType?: RentalType | string;
}

export default function ProductYachtPrices({
    monthlyPrices,
    currency,
    title,
    rentalType = 'daily',
}: ProductYachtPricesProps) {
    if (monthlyPrices.length === 0) return null;

    return (
        <motion.section 
            id="price-detail"
            className="mb-[75px] scroll-mt-20"
            variants={slideFromBottomVariants}
            aria-labelledby="price-detail-heading"
        >
            <motion.h2 
                id="price-detail-heading"
                className="text-xl lg:text-3xl font-bold text-alsero-dark-gray mb-6"
                variants={headerVariants}
            >
                {title}
            </motion.h2>
            
            <motion.div 
                variants={cardVariants}
            >
                <YachtPriceCalendar
                    prices={monthlyPrices}
                    currency={currency}
                    rentalType={rentalType}
                />
            </motion.div>
        </motion.section>
    );
}

